import { AppShell } from './components/AppShell';

export function App() {
  return <AppShell />;
}
